import React, { useState } from 'react';
import TabTitle from "../components/TabTitle";
import './RegisterPage.css';  // 

const RegisterPage = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleRegister = async (e) => {
    e.preventDefault();
    // Adicionar a lógica para o registro do usuário aqui
  };

  return (
    <>
      {/* Atualiza o título da aba */}
      <TabTitle activeTab="RegisterPage" />

      <div className="register-container">
        <form className="register-form" onSubmit={handleRegister}>
          <h2 className="register-header">Criar conta ACADE</h2>
          <input
            type="text"
            className="register-input"
            placeholder="Nome"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <input
            type="email"
            className="register-input"
            placeholder="E-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            className="register-input"
            placeholder="Senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit" className="register-button">Enviar</button>
        </form>
      </div>
    </>
  );
};

export default RegisterPage;
